import Konva from 'konva/src/Core';
import PlacingLayer from './PlacingLayer';
import Design from './design/design';
import helper from 'common/helper';
import EventEmitter from 'common/eventEmitter';

class PlacingEditor {
    constructor(containerId, editorSize, viewpoint, colour, editable) {
        this.events = new EventEmitter();
        this.viewpoint = viewpoint;
        this.colour = colour;
        this.stage = new Konva.Stage({
            container: containerId,
            width: editorSize.width,
            height: editorSize.height
        });
        const viewpointSize = {width: this.viewpoint.width, height: this.viewpoint.height};
        this.placingLayer = new PlacingLayer(viewpointSize, editorSize, colour, editable);
        this.placingLayer.events.on('change', () => this.emitChange());
        this.placingLayer.events.on('instruction', (design) => this.emitInstruction(design));
        this.stage.add(this.placingLayer.konvaLayer);
        this.editable = editable;
    }

    createDesign(data) {
        return new Promise((resolve, reject) => {
            helper.getImage(data.image).then(imgObj => {
                resolve(new Design(data, imgObj, this.editable));
            }, err => reject(err));
        });
    }

    addDesignToLayer(design) {
        return this.createDesign(design).then(designObj => {
            this.placingLayer.addDesign(designObj);
        });
    }

    addDesign(design) {
        return this.addDesignToLayer(design).then(() => {
            this.emitChange();
        });
    }

    setDesigns(designs) {
        const promises = [];
        this.placingLayer.clear();
        designs.forEach(d => {
            promises.push(this.addDesignToLayer(d));
        });
        return Promise.all(promises);
    }

    getDesigns() {
        return this.placingLayer.getDesigns();
    }

    setBackground(imgUrl) {
        return helper.getImage(imgUrl).then(imgObj => {
            this.placingLayer.setBackground(imgObj);
        });
    }

    emitChange() {
        this.events.emit('change', {viewpointName: this.viewpoint.name});
    }

    emitInstruction(design) {
        this.events.emit('instruction', design);
    }

    getImageData(maxSize) {
        return this.placingLayer.getImageData(maxSize);
    }
}

export default PlacingEditor;



// WEBPACK FOOTER //
// ./src/placingEditor/placingEditor.js